import { Component, Input } from '@angular/core';

import { clienteCarteiraTipoPretendida } from '../../cliente-carteira-tipo';

@Component({
    selector: 'sgt-cliente-carteira-tipo-pretendida-badge',
    templateUrl: './cliente-carteira-tipo-pretendida-badge.component.html',
    styleUrls: ['./cliente-carteira-tipo-pretendida-badge.component.less']
})
export class ClienteCarteiraTipoPretendidaBadgeComponent {
    tipo = clienteCarteiraTipoPretendida;

    /** Se o badge está inserido dentro dos badges do título de um card no pipeline */
    @Input() isPipelineCardTitleBadge = false;
    /** ID da classificação de faturamento pretendida */
    @Input() idClassificacaoFaturamentoPretendida: number = null;
    /** Código da classificação de faturamento pretendida */
    @Input() codigoClassificacaoFaturamentoPretendida: string = null;
    /** Nome da classificação de faturamento pretendida */
    @Input() nomeClassificacaoFaturamentoPretendida: string = null;
}
